(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-menu"] && !Shopify.designMode) return;
  try {
    class HeaderMenu extends HTMLElement {
    connectedCallback() {
      this.items = Array.from(this.querySelectorAll('[data-nav-details]'));
      if (!this.items.length) return;

      this.hoverCapable = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      this.closeTimer = null;

      this.items.forEach((details) => {
        const summary = details.querySelector('summary');

        summary.addEventListener('click', (event) => {
          if (details.open) return;
          event.preventDefault();
          this.openOnly(details);
        });

        if (this.hoverCapable) {
          details.addEventListener('mouseenter', () => {
            window.clearTimeout(this.closeTimer);
            this.openOnly(details);
          });

          details.addEventListener('mouseleave', () => {
            this.closeTimer = window.setTimeout(() => this.closeAll(), 160);
          });
        }
      });

      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) this.closeAll();
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.closeAll();
      });

      document.addEventListener('click', (event) => {
        if (!this.contains(event.target)) this.closeAll();
      });
    }

    openOnly(target) {
      this.items.forEach((details) => {
        details.open = details === target;
      });
    }

    closeAll() {
      this.items.forEach((details) => {
        details.open = false;
      });
    }
  }

  if (!customElements.get('header-menu')) {
    customElements.define('header-menu', HeaderMenu);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["header-search"] && !Shopify.designMode) return;
  try {
    class HeaderSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('[data-search-input]');
      this.results = this.querySelector('[data-search-results]');
      this.endpoint = this.dataset.endpoint;
      this.controller = null;
      this.debounce = null;

      this.input.addEventListener('input', () => {
        window.clearTimeout(this.debounce);
        this.debounce = window.setTimeout(() => this.search(), 260);
      });

      this.querySelector('[data-search-close]').addEventListener('click', () => {
        document.dispatchEvent(new CustomEvent('ruq:overlay:close'));
      });

      document.addEventListener('ruq:search:open', () => this.open());
      document.addEventListener('ruq:overlay:close', () => this.close());
    }

    open() {
      this.hidden = false;
      window.requestAnimationFrame(() => this.input.focus());
    }

    close() {
      if (this.hidden) return;
      this.hidden = true;
      this.results.innerHTML = '';
      this.input.value = '';
    }

    async search() {
      const term = this.input.value.trim();

      if (term.length < 2) {
        this.results.innerHTML = '';
        return;
      }

      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      this.classList.add('is-loading');

      const params = new URLSearchParams({
        q: term,
        'resources[type]': 'product,collection,query',
        'resources[limit]': '6',
        section_id: 'predictive-search'
      });

      try {
        const response = await fetch(this.endpoint + '?' + params.toString(), {
          signal: this.controller.signal
        });
        if (!response.ok) throw new Error(response.statusText);

        const markup = await response.text();
        const parsed = new DOMParser().parseFromString(markup, 'text/html');
        const content = parsed.querySelector('[data-predictive-results]');
        this.results.innerHTML = content ? content.innerHTML : '';
      } catch (error) {
        if (error.name !== 'AbortError') this.results.innerHTML = '';
      } finally {
        this.classList.remove('is-loading');
      }
    }
  }

  if (!customElements.get('header-search')) {
    customElements.define('header-search', HeaderSearch);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-card"] && !Shopify.designMode) return;
  try {
    class ProductQuickAdd extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      this.form.addEventListener('submit', (event) => {
        event.preventDefault();
        this.add();
      });
    }

    async add() {
      this.setAttribute('aria-busy', 'true');

      const body = new FormData(this.form);
      body.append('sections', 'cart-drawer');

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: body
        });

        const data = await response.json();
        if (data.status) throw new Error(data.description || data.message);

        const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((res) => res.json());

        document.dispatchEvent(
          new CustomEvent('ruq:cart:updated', {
            detail: { sections: data.sections, item_count: cart.item_count }
          })
        );

        document.dispatchEvent(new CustomEvent('ruq:cart:open'));
      } catch (error) {
        this.form.submit();
      } finally {
        this.removeAttribute('aria-busy');
      }
    }
  }

  if (!customElements.get('product-quick-add')) {
    customElements.define('product-quick-add', ProductQuickAdd);
  }
  } catch(e) { console.error(e); }
})();

})();
